import QualitasLogo from "@/main/assets/images/login/logo-qualitas.png";
import KogInputTextLogin from "@/main/components/shared/inputText/inputTextLogin";
import LoadingComponent from "@/main/components/shared/loading/loadingComponent";
import { SpinnerLoading } from "@/main/components/shared/styles";
import { KeyValue } from "@/main/models/common";
import { ButtonLogin, useStyles } from "@/main/screens/login/styles";
import { getTranslateByKey } from "@/main/services/utils";
import { IconButton } from "@mui/material";
import ArrowForward from "@mui/icons-material/ArrowForward";
import VisibilityOffOutlined from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlined from "@mui/icons-material/VisibilityOutlined";
import React, { useState } from "react";
import * as S from "./styles";

interface IConfirmPasswordScreenQualitasProps {
	translatesLocal: KeyValue[];
	isLoadingTranslates: boolean;
	formResetPassword: any;
}

function ConfirmPasswordScreenQualitas({
	translatesLocal,
	isLoadingTranslates,
	formResetPassword,
}: IConfirmPasswordScreenQualitasProps) {
	const styles = useStyles();

	const [showPassword, setShowPassword] = useState<boolean>(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);

	const handleClickShowPassword = () => setShowPassword(!showPassword);
	const handleClickShowConfirmPassword = () => setShowConfirmPassword(!showConfirmPassword);

	const renderErrors = () => {
		let errors = [];
		if (!formResetPassword.errors.newPassword?.types) return "";
		if (formResetPassword.errors.newPassword?.types?.required)
			errors.push(formResetPassword.errors.newPassword.types.required.toString());
		else {
			errors = Object.values(formResetPassword.errors.newPassword.types);
		}

		return errors.map((error, index) => (
			<React.Fragment key={`error-message-${error}`}>
				{index > 0 && <br />}
				{error}
			</React.Fragment>
		));
	};

	function renderContent() {
		if (isLoadingTranslates) {
			return <LoadingComponent />;
		}

		return (
			<S.FormContainer onSubmit={formResetPassword.submit}>
				<KogInputTextLogin
					autoFocus
					id="txt-recovery-pwd-newpassword"
					className={styles.inputTextCustomQualitas}
					variant="outlined"
					label={getTranslateByKey("information.newPassword", false, translatesLocal)}
					helperText={renderErrors()}
					error={!!formResetPassword.errors.newPassword}
					positionIcon="end"
					type={showPassword ? "text" : "password"}
					icon={
						<IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} edge="end">
							{showPassword ? (
								<VisibilityOutlined style={{ color: "#a31e8d" }} />
							) : (
								<VisibilityOffOutlined style={{ color: "#a31e8d" }} />
							)}
						</IconButton>
					}
					title={getTranslateByKey("information.newPassword", false, translatesLocal)}
					{...formResetPassword.register("newPassword", {
						required: getTranslateByKey("information.newPasswordIsRequired", true, translatesLocal),
						minLength: {
							value: 16,
							message: getTranslateByKey("information.mustHaveAtLeast16Digits", true, translatesLocal),
						},
						maxLength: {
							value: 50,
							message: getTranslateByKey("information.mustNotBeLongerThan50Digits", true, translatesLocal),
						},
						validate: {
							containsUpperCaseLetter: (value: string) =>
								/[A-Z]/.test(value) ||
								getTranslateByKey("information.mustContainAtLeastOneUppercaseLetter", true, translatesLocal),
							containsLowerCaseLetter: (value: string) =>
								/[a-z]/.test(value) ||
								getTranslateByKey("information.mustContainAtLeastOnelowercaseLetter", true, translatesLocal),
							containsDigit: (value: string) =>
								/\d/.test(value) ||
								getTranslateByKey("information.mustContainAtLeastOneNumericCharacter", true, translatesLocal),
							containsSpecialCharacter: (value: string) =>
								/\W/.test(value) ||
								getTranslateByKey("information.mustContainAtLeastOneSpecialCharacter", true, translatesLocal),
						},
					})}
				/>
				<KogInputTextLogin
					id="txt-recovery-pwd-newpassowrd-confirm"
					className={styles.inputTextCustomQualitas}
					variant="outlined"
					label={getTranslateByKey("information.confirmNewPassword", false, translatesLocal)}
					helperText={formResetPassword.errors.confirmPassword?.message || formResetPassword.serverErrors}
					error={!!formResetPassword.errors.confirmPassword || !!formResetPassword.serverErrors}
					positionIcon="end"
					type={showConfirmPassword ? "text" : "password"}
					icon={
						<IconButton aria-label="toggle password visibility" onClick={handleClickShowConfirmPassword} edge="end">
							{showConfirmPassword ? (
								<VisibilityOutlined style={{ color: "#a31e8d" }} />
							) : (
								<VisibilityOffOutlined style={{ color: "#a31e8d" }} />
							)}
						</IconButton>
					}
					title={getTranslateByKey("information.confirmNewPassword", false, translatesLocal)}
					InputLabelProps={{
						style: {
							textOverflow: "ellipsis",
							overflow: "hidden",
							width: 175,
							whiteSpace: "nowrap",
						},
					}}
					{...formResetPassword.register("confirmPassword", {
						required: getTranslateByKey("information.confirmNewPasswordRequired", true, translatesLocal),
						validate: (value: string) =>
							value === formResetPassword.getValues("newPassword") ||
							getTranslateByKey("information.passwordMustBeEquals", true, translatesLocal),
					})}
				/>
				<S.ButtonWrapper>
					<ButtonLogin
						type="submit"
						disabled={formResetPassword.submitInProgress}
						style={{
							margin: 0,
							background: "#a31e8d",
						}}
					>
						{formResetPassword.submitInProgress ? (
							<SpinnerLoading size="xsmall" />
						) : (
							<>
								{getTranslateByKey("information.save", false, translatesLocal)}
								<ArrowForward fontSize="small" />
							</>
						)}
					</ButtonLogin>
				</S.ButtonWrapper>
			</S.FormContainer>
		);
	}

	return (
		<S.Container>
			<S.ConfirmPasswordCard>
				<S.AreaLogo>
					<img src={QualitasLogo} alt="Qualitas Logo" />
				</S.AreaLogo>
				{renderContent()}
			</S.ConfirmPasswordCard>
		</S.Container>
	);
}

export default ConfirmPasswordScreenQualitas;
